/**
 * MediaGalleryModal.jsx
 * Created by michaelbray on 7/11/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Gallery from './Gallery';
import * as Icons from './icons/Icons';

export default class MediaGalleryModal extends React.PureComponent {
    static propTypes = {
        images: PropTypes.array,
        isOpen: PropTypes.bool,
        onRequestClose: PropTypes.func,
        activeIndex: PropTypes.number,
        hasThumbnailStrip: PropTypes.bool
    };

    static defaultProps = {
        images: [],
        isOpen: false,
        activeIndex: 0,
        hasThumbnailStrip: true
    };

    componentDidMount() {
        if (document.getElementById('recApp')) {
            Modal.setAppElement('#recApp');
        }
    }

    render() {
        if (this.props.isOpen) {
            return (
                <Modal
                    isOpen={this.props.isOpen}
                    onRequestClose={this.props.onRequestClose}
                    role="complementary"
                    className={{
                        base: 'rec-modal-dialog-base',
                        afterOpen: 'rec-modal-dialog-after-open-md rec-modal-image-gallery',
                        beforeClose: 'rec-modal-dialog-before-close'
                    }}
                    overlayClassName={{
                        base: 'rec-overlay-base',
                        afterOpen: 'rec-overlay-after-open rec-modal-image-gallery',
                        beforeClose: 'rec-overlay-before-close'
                    }}
                    contentLabel="Media Gallery">
                    <div className="rec-modal-content-wrap">
                        <button
                            className="rec-gallery-close-modal-button"
                            onClick={this.props.onRequestClose}
                            aria-label="Close media gallery">
                            <Icons.IconClose size="lg" />
                        </button>

                        <Gallery
                            images={this.props.images}
                            activeIndex={this.props.activeIndex}
                            hasThumbnailStrip={this.props.hasThumbnailStrip} />
                    </div>
                </Modal>
            );
        }
        return null;
    }
}